module.exports = "<hybse-admin-add-market [actionType]=\"'edit'\" >\n\n</hybse-admin-add-market>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/markets/list-market/edit-market/edit-market.component.html
// module id = ../../../../../src/app/components/pages/markets/list-market/edit-market/edit-market.component.html
// module chunks = main